import { createContext } from "react";
import type { Locale, MessageKey } from "./messages";

export interface I18nContextValue {
  locale: Locale;
  setLocale: (next: Locale) => void;
  t: (key: MessageKey) => string;
}

/**
 * Lives in its own file, apart from `I18nProvider.tsx`, for Vite's React Fast
 * Refresh: the `react-refresh/only-export-components` rule fires on any file
 * that mixes component and non-component exports.
 */
export const I18nContext = createContext<I18nContextValue | null>(null);
